export const BRAND = {
  name: "Gentlemen's Wine Club",
  short: 'GWC',
  established: 1984,
  location: 'Monterey Peninsula, California',
  tagline:
    'We may never be kings, but every now and then we are afforded the opportunity to live like one.',
  // Cream emblem on a true transparent PNG — dark UI backgrounds.
  logoSrc: '/logo-reversed.png',
  // Dark emblem on a true transparent PNG — light UI backgrounds.
  logoOriginal: '/logo-dark.png',
} as const;
